<template>
  <div class="adj-published-container">
    <div class="adj-published-search">
      <div class="adj-search-date">
        <el-date-picker
          :class="'adj-search-date-inp'"
          :editable="false"
          v-model="search.publishBegin"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
        <span class="adj-search-date-sp">至</span>
        <el-date-picker
          :class="'adj-search-date-inp'"
          :editable="false"
          v-model="publishEnd"
          value-format="yyyy-MM-dd"
          type="date"
          placeholder="选择日期"
        >
        </el-date-picker>
      </div>
      <div class="adj-search-kw">
        <el-input
          placeholder="请输入关键字"
          prefix-icon="el-icon-search"
          v-model="search.title"
        >
        </el-input>
      </div>
      <div class="adj-serch-btn">
        <el-button
          @click="searchSubmit()"
          :loading="searchLoading"
          type="primary"
          >搜 索</el-button
        >
      </div>
    </div>
    <div class="adj-published-list">
      <div
        class="adj-published-item"
        v-for="item in dianJinInfo"
        v-bind:key="item.id"
      >
        <!-- 左侧 -->
        <div class="adj-item-left">
          <div
            class="adj-item-cover"
            :style="{
              background: `url(${
                !item.coverImageUrl ? defImg : item.coverImageUrl
              }) no-repeat`,
              'background-size': '100% 100%'
            }"
            @click="goDetail(item.id)"
          >
            <span class="adj-item-needPay" v-if="!item.isFree">收费</span>
          </div>
          <div class="adj-item-content">
            <div class="adj-item-title">
              <span @click="goDetail(item.id)" class="adj-item-text">{{
                item.title
              }}</span>
              <span
                class="adj-item-state"
                :class="{ 'adj-item-state-unline': item.status !== 2 }"
                >{{ item.status === 2 ? '已发布' : '待发布' }}</span
              >
            </div>
            <span class="adj-item-date">{{
              getDateFormat(item.createTime)
            }}</span>
          </div>
        </div>
        <!-- 图标 -->
        <div class="adj-item-right">
          <div class="adj-item-top">
            <!-- <div @click="goEdit(item)" class="adj-item-edit"></div> -->
            <div @click="Delete(item)" class="adj-item-del"></div>
          </div>
          <div class="adj-item-bottom">
            <div class="adj-item-view">
              <i class="adj-item-bottom-i adj-item-icon-view">{{
                item.viewsCount
              }}</i>
            </div>
            <div class="adj-item-comment" @click="goDetail(item.id, 'comm')">
              <i class="adj-item-bottom-i adj-item-icon-comment">{{
                item.commentsCount
              }}</i>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-loading="loading"
      class="adj-published-load-more"
      :class="{ 'adj-published-load-more-end': listEnd }"
    >
      <span @click="loadMore"
        >{{ listEnd ? '已经没有更多了' : '点击查看更多' }}
      </span>
    </div>
  </div>
</template>

<script>
import { authorGetPage, authorRemove } from '@/api/dianjin'
import autioDef from './images/audio-def.png'
export default {
  name: 'Published',
  data() {
    return {
      dianJinInfo: [],
      defImg: autioDef,
      pageState: { pageIndex: 0, pageSize: 5 },
      maxPage: 0,
      search: {
        title: '',
        publishBegin: '',
        publishEnd: ''
      },
      loadMoreSearch: {},
      searchLoading: false,
      loading: false
    }
  },
  computed: {
    listEnd() {
      return this.pageState.pageIndex >= this.maxPage
    },
    publishEnd: {
      get() {
        if (!this.search.publishEnd) {
          return ''
        }
        // 读取为上一天
        var newDate = new Date(
          new Date(this.search.publishEnd).getTime() - 24 * 60 * 60 * 1000
        )
        var res = `${newDate.getFullYear()}-${(newDate.getMonth() + 1)
          .toString()
          .padStart(2, 0)}-${newDate.getDate().toString().padStart(2, 0)}`
        return res
      },
      set(newValue) {
        if (!newValue) {
          this.search.publishEnd = ''
          return newValue
        }
        // 设置为下一天
        var newDate = new Date(
          new Date(newValue).getTime() + 24 * 60 * 60 * 1000
        )
        this.search.publishEnd = `${newDate.getFullYear()}-${(
          newDate.getMonth() + 1
        )
          .toString()
          .padStart(2, 0)}-${newDate.getDate().toString().padStart(2, 0)}`
        return newValue
      }
    }
  },
  methods: {
    // 获取列表
    async initList() {
      var searchInfo = {}
      Object.assign(searchInfo, this.search, this.pageState)

      var { result, detail } = await authorGetPage(searchInfo)
      if (result.code === 0) {
        this.maxPage = detail.maxPage
        this.dianJinInfo = detail.list
      } else {
        console.log('error result:', result)
        this.$notify.error({
          position: 'bottom-right',
          title: '错误',
          message: '数据请求发生异常，请稍后再试。'
        })
      }
    },
    goDetail(id, hashName) {
      var url = `/dianjin/${id}`
      if (hashName) {
        url = `${url}#${hashName}`
      }
      var routeUrl = this.$router.resolve(url)
      window.open(routeUrl.href, '_blank')
    },
    async searchSubmit() {
      this.searchLoading = true
      this.pageState.pageIndex = 0
      this.loadMoreSearch = this.search
      await this.initList()
      this.searchLoading = false
    },
    // 加载更多
    async loadMore() {
      if (this.listEnd) {
        return
      }
      this.loading = true
      var searchInfo = {}
      this.pageState.pageIndex += 1
      Object.assign(searchInfo, this.loadMoreSearch, this.pageState)
      var { result, detail } = await authorGetPage(searchInfo)
      if (result.code === 0) {
        this.maxPage = detail.maxPage

        detail.list.forEach(item => {
          this.dianJinInfo.push(item)
        })
        this.loading = false
      } else {
        this.loading = false
        console.log('error result:', result)
        this.$notify.error({
          position: 'bottom-right',
          title: '错误',
          message: '数据请求发生异常，请稍后再试。'
        })
      }
    },
    // 转到编辑
    goEdit(info) {
      this.$emit('goEdit', info.id)
    },
    // 删除
    Delete(info) {
      this.$confirm(`确定要删除【${info.title}】?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(async () => {
          const { result, detail } = await authorRemove(info.id)
          if (result.code === 0 && detail) {
            this.dianJinInfo = this.dianJinInfo.filter(x => x.id !== info.id)
            this.$message({
              type: 'success',
              message: '删除成功!'
            })
          } else {
            this.$message({
              type: 'error',
              message: '删除失败，请稍后重试!'
            })
          }
        })
        .catch(() => {})
    },
    // 获取时间string
    getDateFormat(createTime) {
      if (!createTime) {
        return ''
      }
      var date = new Date(createTime)
      return `${date.getFullYear()}-${(date.getMonth() + 1)
        .toString()
        .padStart(
          2,
          0
        )}-${date.getDate()} ${date.getHours()}:${date.getMinutes()}:${date
        .getSeconds()
        .toString()
        .padStart(2, 0)}`
    }
  },
  async mounted() {
    await this.initList()
  },
  created() {}
}
</script>
<style>
body .adj-published-container .adj-serch-btn .el-button--primary {
  height: 38px;
  margin-bottom: 1px;
  width: 100px;
}
body .adj-published-container .adj-serch-btn .el-button--primary > span {
  line-height: 12px;
}
</style>
<style lang="scss" scoped>
.adj-published-container {
  display: flex;
  flex-direction: column;
  .adj-published-search {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    .adj-search-date {
      .adj-search-date-inp {
        width: 200px;
        text-align: center;
      }
      .adj-search-date-sp {
        font-family: MicrosoftYaHei;
        font-size: 14px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 40px;
        letter-spacing: 1px;
        color: #858585;
        margin: 0 10px;
      }
    }
    .adj-search-date {
      display: flex;
    }
    .adj-search-kw {
      display: flex;
      width: 200px;
      margin-left: 20px;
    }
    .adj-serch-btn {
      margin-left: 20px;
      display: flex;
    }
  }
  .adj-published-list {
    margin-top: 30px;
    display: flex;
    flex-direction: column;
    .adj-published-item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 866px;
      height: 160px;
      background-color: #ffffff;
      border-radius: 5px;
      margin-bottom: 20px;
      .adj-item-left {
        display: flex;
        .adj-item-cover {
          width: 160px;
          height: 120px;
          margin-left: 20px;
          cursor: pointer;
        }
        .adj-item-needPay {
          width: 50px;
          height: 22px;
          background-color: #046bcc;
          font-family: MicrosoftYaHei;
          font-size: 14px;
          font-weight: normal;
          font-stretch: normal;
          line-height: 22px;
          letter-spacing: 1px;
          color: #ffffff;
          display: flex;
          justify-content: center;
        }
        .adj-item-content {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          margin-left: 20px;
          height: 120px;
          .adj-item-title {
            display: flex;
            align-items: center;
            .adj-item-text {
              font-family: MicrosoftYaHei;
              font-size: 20px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 40px;
              letter-spacing: 1px;
              color: #262626;
              max-width: 500px;
              cursor: pointer;
            }
            :hover {
              color: #046bcc;
            }
            .adj-item-state {
              width: 60px;
              height: 22px;
              background-color: rgb(4, 107, 204, 0.1);
              border-radius: 5px;
              font-family: MicrosoftYaHei;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 22px;
              letter-spacing: 1px;
              color: #046bcc;
              display: inline-block;
              text-align: center;
              margin-left: 7px;
            }
            .adj-item-state-unline {
              background-color: rgb(133, 133, 133, 0.1);
              color: #858585;
            }
          }
          .adj-item-date {
            width: 185px;
            font-family: MicrosoftYaHei;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 24px;
            letter-spacing: 1px;
            color: #858585;
          }
        }
      }
      .adj-item-right {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        // width: 66px;
        height: 120px;
        margin-right: 20px;
        .adj-item-top {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          height: 40px;
          .adj-item-edit {
            width: 22px;
            height: 22px;
            background: url('./images/edit.png') no-repeat;
            cursor: pointer;
          }
          .adj-item-del {
            width: 22px;
            height: 22px;
            background: url('./images/del.png') no-repeat;
            cursor: pointer;
          }
        }
        .adj-item-bottom {
          display: flex;
          justify-content: center;

          .adj-item-bottom-i {
            font-family: MicrosoftYaHei;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 15px;
            letter-spacing: 1px;
            color: #858585;
            display: flex;
            font-style: unset;

            &::before {
              content: '';
              width: 20px;
              height: 15px;
              display: flex;
              margin-right: 5px;
            }
          }
          .adj-item-icon-view {
            &::before {
              background: url('./images/view.png') no-repeat center right;
            }
          }
          .adj-item-icon-comment {
            &::before {
              background: url('./images/comment.png') no-repeat center right;
            }
          }

          .adj-item-view {
            .adj-item-view-icon {
              font-family: PingFangSC-Regular;
              font-size: 14px;
              font-weight: normal;
              font-stretch: normal;
              line-height: 40px;
              letter-spacing: 0px;
              color: #858585;
              &::before {
                margin-right: 5px;
              }
            }
          }

          .adj-item-comment {
            display: flex;
            align-items: center;
            margin-left: 40px;
            cursor: pointer;

            .adj-item-comment-icon {
              width: 16px;
              height: 16px;
              background: url('./images/comment.png') no-repeat;
            }
          }
          .adj-item-bottom-num {
            font-family: MicrosoftYaHei;
            font-size: 14px;
            font-weight: normal;
            font-stretch: normal;
            line-height: 14px;
            letter-spacing: 1px;
            color: #858585;
            margin-left: 7px;
          }
        }
      }
    }
  }
  .adj-published-load-more {
    width: 866px;
    height: 40px;
    background-color: #ffffff;
    border-radius: 5px;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    line-height: 40px;
    letter-spacing: 1px;
    color: #046bcc;
    display: flex;
    justify-content: center;
    cursor: pointer;
    margin: 10px auto;
  }
  .adj-published-load-more-end {
    cursor: auto;
    color: #858585;
  }
}
</style>
